<template>
    <div id="auditions" class="bg-zinc-950">
        <div class="max-w-[1400px] mx-auto px-4 sm:px-6 py-6 lg:py-8 pb-24 lg:pb-8">
            <!-- MyNA banner promo -->
            <div v-if="useMyNaPromo === 'banner'" class="mb-4 lg:mb-6">
                <div class="relative bg-zinc-900 border border-white/[0.08] border-l-2 border-l-amber-500/70 rounded-lg overflow-hidden">
                    <div class="flex items-center gap-3 px-3 sm:px-4 py-2.5 min-h-[56px]">
                        <!--<div class="flex-shrink-0 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-amber-500/15 border border-amber-500/25">
                            <Sparkles class="w-3 h-3 text-amber-400" />
                            <span class="text-[10px] font-bold text-amber-300 uppercase tracking-wider">New</span>
                        </div>-->
                        <p class="flex-1 min-w-0 text-white/80 text-sm leading-snug">
                            <span class="hidden sm:inline">Your stars now build your public Sponsor Profile — earn badges &amp; climb the leaderboard</span>
                            <span class="sm:hidden">Stars build your Sponsor profile — badges &amp; leaderboard</span>
                        </p>
                        <img src="https://sm.naughtycdn.com/images/feeds/myna-promo.png" alt="Sponsor page preview" class="hidden sm:block flex-shrink-0 h-[42px] w-auto rounded border border-white/10 object-fill object-top">
                        <button type="button"
                                @click="$emit('myNaClicked')"
                                class="flex-shrink-0 text-blue-400 hover:text-blue-300 text-sm font-semibold transition-colors whitespace-nowrap"
                        >
                            View Your Page →
                        </button>
                        <!--<button class="flex-shrink-0 w-7 h-7 rounded-md hover:bg-white/10 flex items-center justify-center transition-colors" aria-label="Dismiss">
                            <X class="w-3.5 h-3.5 text-white/40" />
                        </button>-->
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div v-if="!loadingPosts && posts.length === 0" class="text-center sm:py-16">
                <!-- Search empty state -->
                <template v-if="searchQuery">
                    <h3 class="text-xl font-bold text-white mb-2">
                        Looking for <span class="text-auditionsBlue">"{{ searchQuery }}"</span>
                    </h3>
                    <p class="text-gray-500 mb-6">
                        Submit your pitch and start your studio.
                    </p>
                    <button
                        @click="handleRequestAuditionClick"
                        class="px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg transition-all shadow-lg shadow-purple-500/25"
                    >
                        Create Your Pitch
                    </button>
                </template>

                <!-- Default empty state -->
                <template v-else>
                    <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-500/10 border border-blue-500/20 mb-4">
                        <img src="https://sm.naughtycdn.com/images/landers/prize/NA-Star.png" alt="" class="w-8 h-8" />
                    </div>
                    <h3 class="text-xl font-semibold text-white mb-2">
                        {{ view === 'mine' ? 'No sponsorships yet' : 'No auditions available' }}
                    </h3>
                    <p class="text-gray-500 mb-6">
                        {{
                            view === 'mine'
                                ? 'Start supporting performers by giving stars to auditions you love'
                                : 'Check back soon for new auditions'
                        }}
                    </p>
                    <button
                        v-if="view === 'mine'"
                        @click="$emit('updateCurrentView', 'all')"
                        class="px-6 py-3 bg-auditionsBlue hover:bg-auditionsBlueHover text-white font-semibold rounded-lg transition-colors"
                    >
                        Explore Auditions
                    </button>
                    <button
                        v-else-if="!isUserLoggedIn"
                        @click="$emit('updateCurrentView', 'all')"
                        class="px-6 py-3 text-white bg-auditionsBlue hover:bg-auditionsBlueHover font-semibold rounded-lg transition-colors"
                    >
                        Browse Auditions
                    </button>
                </template>
            </div>

            <!-- Videos Grid -->
            <template v-else>
                <!-- MOBILE: Two-Column Grid -->
                <div class="lg:hidden">
                    <MobileVideosGrid
                        :posts="posts"
                        :isUserLoggedIn="isUserLoggedIn"
                        :routePrefix="routePrefix"
                        :requiresAgeVerification="requiresAgeVerification"
                        :useMyNaPromo="useMyNaPromo"
                        @goToFeed="$emit('goToFeed', $event)"
                        @prefetchFeed="$emit('prefetchFeed', $event)"
                        @hideVideo="hideVideo"
                        @showVideo="showVideo"
                        @setBufferingState="setBufferingState"
                        @videoClick="$emit('videoClick', $event)"
                        @navigateToScene="$emit('navigateToScene', $event)"
                        @myNaClicked="$emit('myNaClicked')"
                    />
                </div>

                <!-- DESKTOP: Four-Column Grid -->
                <div class="hidden lg:grid grid-cols-4 gap-6">
                    <div v-if="useMyNaPromo === 'card'"
                         @click="$emit('myNaClicked')"
                         class="cursor-pointer group relative bg-zinc-900 overflow-hidden text-left flex flex-col h-full ring-1 ring-amber-500/30 shadow-lg shadow-amber-500/10 rounded-xl">
                        <!--<button class="absolute top-2 right-2 z-20 w-7 h-7 rounded-full bg-black/50 backdrop-blur-sm hover:bg-black/70 flex items-center justify-center transition-colors" aria-label="Dismiss">
                            <X class="w-3.5 h-3.5 text-white/70" />
                        </button>-->
                        <div class="relative w-full aspect-[3/4] overflow-hidden flex-shrink-0 ">
                            <img src="https://sm.naughtycdn.com/images/feeds/myna-promo.png" alt="Sponsor Profile Page" class="w-full h-full object-fill object-top">
                            <div class="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/30"></div>
                            <!--<div class="absolute top-3 left-3">
                                <div class="inline-flex items-center gap-1 px-2 py-1 rounded-md min-h-[22px] text-xs font-bold tracking-wide uppercase bg-amber-500/90 text-black shadow-sm">
                                    <Sparkles class="w-3 h-3" />
                                    New
                                </div>
                            </div>-->
                            <div class="absolute inset-0 flex flex-col items-center justify-center px-3 text-center">
                                <h3 class="text-white font-bold leading-tight mb-1 text-lg">Your Sponsor Profile</h3>
                                <p class="text-white/70 leading-snug max-w-[90%] text-xs">Every star builds your bragging rights</p>
                            </div>
                            <div class="absolute bottom-0 left-0 right-0 p-2.5">
                                <div class="flex items-center justify-center gap-3">
                                    <div class="flex items-center gap-1">
                                        <img src="https://sm.naughtycdn.com/images/landers/prize/NA-Star.png" alt="" class="w-3 h-3">
                                        <span class="text-white/80 text-[10px] font-semibold">Stars</span>
                                    </div>
                                    <div class="flex items-center gap-1">
                                        <Trophy class="w-3 h-3 text-amber-400" />
                                        <span class="text-white/80 text-[10px] font-semibold">Rank</span>
                                    </div>
                                    <div class="flex items-center gap-1">
                                        <Award class="w-3 h-3 text-amber-400" />
                                        <span class="text-white/80 text-[10px] font-semibold">Badges</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-4 flex flex-col flex-1">
                            <p class="text-white/50 mb-2 text-sm">Earn badges &amp; climb the leaderboard</p>
                            <div class="mt-auto">
                                <button v-if="isUserLoggedIn" type="button" class="w-full flex items-center justify-center gap-1.5 bg-white/10 hover:bg-white/15 border border-white/15 text-white font-bold rounded-lg transition-all active:scale-95 py-2.5 text-sm" data-id="element-140">
                                    View Your Page
                                    <ExternalLink class="w-3.5 h-3.5" />
                                </button>
                                <button v-else type="button" class="w-full flex items-center justify-center gap-1.5 bg-white/10 hover:bg-white/15 border border-white/15 text-white font-bold rounded-lg transition-all active:scale-95 py-2.5 text-sm" data-id="element-140">
                                    Build Your Page
                                </button>
                            </div>
                        </div>
                    </div>
                    <Link
                        v-for="post in posts"
                        :key="post.id"
                        href="#"
                        @click.prevent="$emit('goToFeed', post)"
                        @mouseenter="!requiresAgeVerification && !isBillerExpired(post) && showVideo(post)"
                        @mouseleave="!requiresAgeVerification && !isBillerExpired(post) && hideVideo(post)"
                        title="Watch audition preview"
                        :class="[
                            'group relative bg-zinc-900 rounded-xl overflow-hidden transition-all text-left flex flex-col h-full',
                            isBillerExpired(post) ? 'opacity-50' : '',
                            post.sponsored_by_user
                                ? 'ring-2 ring-blue-500/30 shadow-lg shadow-blue-500/10'
                                : !requiresAgeVerification ? 'hover:ring-2 hover:ring-white/20' : ''
                        ]"
                    >
                        <!-- Thumbnail -->
                        <div class="relative w-full aspect-[3/4] bg-gradient-to-br from-zinc-800 to-zinc-900 overflow-hidden flex-shrink-0">
                            <picture v-if="requiresAgeVerification">
                                <source
                                    :srcset="post.lock.start_card_video_images?.image_600x1066_webp"
                                    type="image/webp"/>
                                <source
                                    :srcset="post.lock.start_card_video_images?.image_600x1066 ?
                                        post.lock.start_card_video_images.image_600x1066 :
                                        'https://sm.naughtycdn.com/images/brokenImage.png'"
                                    type="image/jpeg"/>

                                <img
                                    v-show="!post.showVideo"
                                    :title="post.title"
                                    :alt="post.title"
                                    alt="Image"
                                    width="297"
                                    height="526"
                                    :class="{
                                        'is_not_vertical h-full w-full object-contain text-white': !post.is_vertical,
                                        'is_vertical h-full w-full object-cover text-white': post.is_vertical,
                                        locked: post.is_locked,
                                        unlocked: !post.is_locked,
                                    }"
                                    :src="post.lock.start_card_video_images?.image_600x1066_webp"/>
                            </picture>
                            <picture v-else>
                                <source
                                    :srcset="post.start_card_images?.image_600x1066_webp"
                                    type="image/webp"/>
                                <source
                                    :srcset="post.start_card_images?.image_600x1066 ?
                                        post.start_card_images.image_600x1066 :
                                        'https://sm.naughtycdn.com/images/brokenImage.png'"
                                    type="image/jpeg"/>

                                <img
                                    v-show="!post.showVideo"
                                    :title="post.title"
                                    :alt="post.title"
                                    alt="Image"
                                    width="297"
                                    height="526"
                                    :class="{
                                        'is_not_vertical h-full w-full object-contain text-white': !post.is_vertical,
                                        'is_vertical h-full w-full object-cover text-white': post.is_vertical,
                                        locked: post.is_locked,
                                        unlocked: !post.is_locked,
                                    }"
                                    :src="post.start_card_images?.image_600x1066_webp"/>
                            </picture>

                            <div
                                v-if="!requiresAgeVerification && post.buffering && !post.is_locked && post.showVideo"
                                class="loading spinner z-[100]">
                                <span class="text-white"></span>
                            </div>
                            <video
                                v-if="!requiresAgeVerification && post.showVideo"
                                :ref="el => { if (el) videoRefs.set(post.id, el) }"
                                :poster="post.start_card_images?.image_600x1066_webp"
                                :class="['w-full h-full object-cover opacity-90 transition-transform duration-300', !requiresAgeVerification && 'group-hover:scale-105']"
                                :title="post.title"
                                :alt="post.title"
                                muted
                                loop
                                webkit-playsinline
                                playsinline
                                preload="metadata"
                                @waiting="() => setBufferingState(post, true)"
                                @playing="() => setBufferingState(post, false)"
                                @loadstart="() => setBufferingState(post, true)"
                                disableremoteplayback
                            >
                                <source :src="post.is_locked ? '' : post.videoUrl_mp4_unbranded || post.videoUrl_mp4" type="video/mp4"/>
                            </video>

                            <!-- New Badge -->
                            <div v-if="post.is_new" class="absolute top-3 left-3">
                                <NewChip />
                            </div>

                            <!-- Status Badge -->
                            <div class="absolute top-3 right-3">
                                <StatusBadgeRight :audition="post" />
                            </div>

                            <!-- Expired Pill -->
                            <div v-if="isBillerExpired(post)" class="absolute bottom-3 left-3">
                                <div class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold backdrop-blur-sm bg-zinc-700/80 text-white/60 border border-white/10">
                                    <Ban class="w-3 h-3 flex-shrink-0" />
                                    Expired
                                </div>
                            </div>

                            <!-- FOMO Expiry Pill -->
                            <div v-else-if="!post.star_goal_reached && isExpiringSoon(post)" class="absolute bottom-3 left-3">
                                <div :class="[
                                    'inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold backdrop-blur-sm',
                                    getExpiresInDays(post) <= 2
                                        ? 'bg-rose-600/80 text-white border border-rose-500/50'
                                        : getExpiresInDays(post) <= 5
                                            ? 'bg-orange-500/80 text-white border border-orange-400/50'
                                            : 'bg-amber-500/80 text-white border border-amber-400/50'
                                ]">
                                    🔥 {{ getFomoLabel(post) }}
                                </div>
                            </div>

                            <!-- Sponsored Indicator -->
                            <div v-if="post.sponsored_by_user" class="absolute bottom-3 right-3">
                                <div class="relative">
                                    <div class="absolute inset-0 bg-blue-500/20 rounded-full blur-sm" />
                                    <div class="relative w-10 h-10 rounded-full bg-blue-500/15 border border-blue-500/30 flex items-center justify-center">
                                        <img :src="STAR_ICON_URL" alt="" class="w-5 h-5" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Card Content -->
                        <div class="p-4 flex flex-col flex-1">
                            <h3 class="text-white font-bold text-base mb-1 line-clamp-2 min-h-[2.5rem]">
                                {{ post.title }}
                            </h3>
                            <p class="text-white/50 text-sm mb-3 line-clamp-1">
                                {{ post.creator.name }}
                            </p>

                            <div class="mt-auto">
                                <!-- Biller Expired Status -->
                                <div v-if="isBillerExpired(post)" class="space-y-2">
                                    <div class="py-2.5 bg-zinc-700/30 border border-white/10 rounded-lg text-center flex items-center justify-center gap-1.5">
                                        <Ban class="w-3.5 h-3.5 text-white/40" />
                                        <p class="text-white/40 font-semibold text-sm">Expired</p>
                                    </div>
                                </div>

                                <!-- New/Almost Status -->
                                <div
                                    v-else-if="!post.star_goal_reached"
                                    class="space-y-2"
                                >
                                    <div class="flex items-center justify-between text-xs">
                                        <span class="text-white/45 font-medium">
                                          {{ post.likes }} of {{ post.star_goal }}
                                        </span>
                                        <span class="text-white/90 font-bold">
                                          {{ getStarsNeeded(post) }} Stars to be sponsored
                                        </span>
                                    </div>

                                    <div
                                        :class="[
                                            'relative h-2 rounded-full overflow-hidden',
                                            post.is_near_goal ? 'animate-pulse' : ''
                                        ]"
                                        style="background-color: #2F2F2F;"
                                    >
                                        <div
                                            v-if="getPercentage(post) > 0"
                                            :class="[
                                                'absolute inset-y-0 left-0 rounded-full transition-all duration-300',
                                                post.sponsored_by_user
                                                    ? 'bg-gradient-to-r from-blue-500 to-blue-400'
                                                    : 'bg-gradient-to-r from-blue-600 to-blue-500'
                                            ]"
                                            :style="{ width: `${Math.min(getPercentage(post), 100)}%` }"
                                        />
                                    </div>

                                    <div class="flex items-center justify-between text-xs min-h-[1rem]">
                                        <span v-if="post.expires_at && getExpiresInDays(post) >= 0" class="flex items-center gap-1 text-white/40">
                                            <Clock class="w-3 h-3 flex-shrink-0" />
                                            {{ getExpiresInDays(post) === 0 ? 'Expires today' : `${getExpiresInDays(post)} day${getExpiresInDays(post) === 1 ? '' : 's'} remaining` }}
                                        </span>
                                        <span v-else class="text-white/40"> </span>
                                        <span
                                            v-if="post.sponsored_by_user && post.stars_given_by_user > 0"
                                            class="text-blue-400 font-bold flex items-center gap-1"
                                        >
                                            You: {{ post.stars_given_by_user }}
                                            <img :src="STAR_ICON_URL" alt="star" class="w-3 h-3 inline-block" />
                                        </span>
                                    </div>
                                </div>

                                <!-- Sponsored Status -->
                                <div v-if="post.star_goal_reached && !post.release_status" class="space-y-2">
                                    <div class="py-2.5 bg-sky-500/10 border border-sky-400/20 rounded-lg text-center flex items-center justify-center gap-1.5">
                                        <Check class="w-3.5 h-3.5 text-sky-400" :stroke-width="3" />
                                        <p class="text-sky-300 font-semibold text-sm">
                                            Sponsored
                                        </p>
                                    </div>
                                </div>

                                <!-- Production Status -->
                                <div v-if="post.release_status == 1" class="space-y-2">
                                    <div class="py-2.5 bg-amber-500/10 border border-amber-400/20 rounded-lg text-center flex items-center justify-center gap-1.5">
                                        <Film class="w-3.5 h-3.5 text-amber-400" />
                                        <p class="text-amber-300 font-semibold text-sm">
                                            In Production
                                        </p>
                                    </div>
                                </div>

                                <!-- Released Status -->
                                <div v-if="post.release_status == 2 && post.scene_slug" class="space-y-2">
                                    <a
                                        :href="route(routePrefix + '.scene.show', post.scene_slug)"
                                        target="_blank"
                                        @click.stop="handleWatchReleasedSceneClick(post)"
                                        class="block w-full py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg transition-colors"
                                    >
                                        <div class="flex items-center justify-center gap-2 mb-1">
                                            <Play class="w-4 h-4" fill="white" />
                                            <span class="text-sm font-bold">
                                                Watch Released Scene
                                            </span>
                                        </div>
                                        <p v-if="post.released_at" class="text-white/70 text-xs text-center">
                                            Released {{ formatReleaseDate(post.released_at) }}
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </template>
        </div>

        <div v-if="loadingPosts" class="h-20 w-full flex items-center justify-center">
            <div class="spinner">
                <span class="text-white"></span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Play, Check, Film, Sparkles, X, Trophy, Award, ExternalLink, Clock, Ban } from 'lucide-vue-next'
import NewChip from './NewChip.vue'
import StatusBadgeRight from './StatusBadgeRight.vue'
import { ref, nextTick, onBeforeUnmount } from "vue"
import { Link } from "@inertiajs/vue3"
import MobileVideosGrid from "@/Components/Reels/MobileVideosGrid.vue";
import {trackAuditionAnalyticsEvent} from "@/Helpers/auditions";
import {getFathomPagePrefix, trackFathomEvent} from "@/Helpers/analytics";

const STAR_ICON_URL = 'https://sm.naughtycdn.com/images/landers/prize/NA-Star.png'

const props = defineProps({
    posts: {
        type: Array,
        required: true
    },
    view: {
        type: String,
        required: true,
        validator: (value) => ['all', 'explore', 'mine', 'released', 'sponsored'].includes(value)
    },
    isUserLoggedIn: {
        type: Boolean,
    },
    loadingPosts: {
        type: Boolean,
        default: false
    },
    routePrefix: {
        type: String
    },
    requiresAgeVerification: {
        type: Boolean,
        default: false
    },
    useMyNaPromo: {
        type: String,
        required: false,
        validator: (value) => ['banner', 'card'].includes(value)
    },
    searchQuery: {
        type: String,
        default: ''
    }
})

const emit = defineEmits([
    'updateCurrentView',
    'videoClick',
    'navigateToScene',
    'goToFeed',
    'prefetchFeed',
    'myNaClicked',
    'castingClick',
])

const playingItem = ref(null)
const isTransitioning = ref(false)
const videoRefs = ref(new Map())

const stopAllVideos = () => {
    props.posts.forEach(post => {
        if (post.showVideo) {
            post.showVideo = false
            const videoEl = videoRefs.value.get(post.id)
            if (videoEl) {
                videoEl.pause()
                videoEl.currentTime = 0
            }
        }
    })
    playingItem.value = null
}

const showVideo = async (item) => {
    // Prevent multiple rapid calls
    if (isTransitioning.value || item.showVideo) return
    isTransitioning.value = true

    // Hide other videos
    if (playingItem.value !== null && playingItem.value !== item) {
        props.posts.forEach(row => {
            if (row !== item && row.showVideo) {
                row.showVideo = false
                const videoEl = videoRefs.value.get(row.id)
                if (videoEl) {
                    videoEl.pause()
                    videoEl.currentTime = 0
                }
            }
        })
    }

    item.showVideo = true
    playingItem.value = item

    await nextTick()
    const videoEl = videoRefs.value.get(item.id)
    if (videoEl && !item.is_locked) {
        try {
            videoEl.load()
            await videoEl.play()
        } catch (error) {
            console.log('Video play failed:', error)
        }
    }

    isTransitioning.value = false
}

const hideVideo = (item) => {
    if (isTransitioning.value) return

    if (playingItem.value === item) {
        playingItem.value = null
    }
    item.showVideo = false

    const videoEl = videoRefs.value.get(item.id)
    if (videoEl) {
        videoEl.pause()
        videoEl.currentTime = 0
    }
}

const setBufferingState = (item, state) => {
    item.buffering = state
}

const getPercentage = (post) => {
    return (post.likes / post.star_goal) * 100
}

const getStarsNeeded = (post) => {
    return Math.max(0, post.star_goal - post.likes)
}

const formatReleaseDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
    })
}

// Clean up on component unmount
onBeforeUnmount(() => {
    stopAllVideos()
    videoRefs.value.clear()
})

const handleWatchReleasedSceneClick = (post) => {
    trackAuditionAnalyticsEvent('Watch Scene Button Clicked', post);
    window.open(route(props.routePrefix + '.scene.show', post.scene_slug), '_blank')
}

// Watch for window resize to detect view changes
if (typeof window !== 'undefined') {
    let resizeTimeout
    const handleResize = () => {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(() => {
            stopAllVideos()
        }, 100)
    }

    window.addEventListener('resize', handleResize)

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize)
    })
}

const isBillerExpired = (post) => post.feed_post_status == 3

const getExpiresInDays = (post) => {
    if (!post.expires_at) return null
    return Math.ceil((new Date(post.expires_at) - new Date()) / (1000 * 60 * 60 * 24))
}

const isExpiringSoon = (post) => {
    const days = getExpiresInDays(post)
    return days !== null && days >= 0 && days <= 7
}

const getFomoLabel = (post) => {
    const days = getExpiresInDays(post)
    if (days === null) return ''
    if (days === 0) return "Don't miss out — ends today!"
    if (days <= 2) return 'This is your last chance'
    if (days <= 5) return 'Going away soon'
    return 'This will leave soon'
}

const handleRequestAuditionClick = () => {
    trackFathomEvent(getFathomPagePrefix(props.routePrefix) + '_Request_Audition_Clicked')
    emit('castingClick')
}

</script>
